import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import { loadingStatus } from "actions"
import _ from "lodash"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import request from "superagent"
import { Formik, Field, Form } from "formik"
import { toast } from "react-toastify"
import settings from "settings"
import ReactSelect from "components/ReactSelect"
import * as Yup from "yup"
import Dropzone from "react-dropzone"
import helpers from 'helpers/helpers'
import moment from 'moment'

class LotImport extends Component {
	constructor(props) {
		super(props)

		this.state = {
			ready: false,
			filename: "",
			fields: {
				property: 0,
				neighborhood: 0,
				lot_type: 0,
				mud: null,
				lid: null,
				isd: null,
			},
		}
	}

	validation = () => {
		return Yup.object().shape({
			property: Yup.number().moreThan(0, "Please choose an option.").required("Required"),
			neighborhood: Yup.number().moreThan(0, "Please choose an option.").required("Required"),
			lot_type: Yup.number().moreThan(0, "Please choose an option.").required("Required"),
			//section_id: Yup.number().moreThan(0).required("Required"),
		})
	}

	onDrop = (files, f, k) => {
		//console.log(files, data)
		//console.log(this.props)
		//return
		this.props.loadingStatus(true)
		const req = request.post(`${settings.ep}/inputLotImport`)
		req.attach(files[0].name, files[0])
		req.set("Authorization", `Bearer ${localStorage.user}`)
		req.end((err, response) => {
			//return
			let resp = response.body

			if (err) {
				console.log(err)
				toast.error(resp.message)
			}
			if (resp.status == 200) {
				toast.success(resp.message)
				f.setFieldValue("filename", resp.filename)
				this.setState({ ready: true, filename: resp.filename })
			}
			this.props.loadingStatus(false)
		})
	}

	propertyLimited = (f, name) => {
		let ret = []
		_.forEach(this.props.payload.public[name], (v) => {
			if (v.property == f.values.property) {
				ret.push({
					label: v.name,
					value: v.id,
				})
			}
		})
		return ret
	}

	options = (name) => {
		let opts = []
		_.forEach(this.props.payload.public[name], (v) => {
			opts.push({ label: v.name, value: v.id })
		})
		return opts
	}

	submitClasses(f) {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f && this.state.ready,
		})

		return submitClasses
	}

	buildSiteIDs = () => {
		let sites = _.map(this.props.payload.public.sites, v => <li>{v.name}: {v.id}</li>)
		return (<ul className="styled">{sites}</ul>)
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="admin">
					<Title title="Lot Import Tool" showDate={false} />
					<div className="content">
						<ul className="list">
							<li>
								Each Section’s template is prepared separately by Lot Type. If a Section has more than
								one Lot Type, more than one template will be required for that Section.
							</li>
							<li>Ensure all numbers are without formatting, e.g. $75000 should be 75000.  Decimal points are allowed (75000.50).</li>
							<li>
								Section, Builder, and Site must utilize ID numbers instead of text.
							</li>
							<li>
								<a
									href={`${settings.s3}/lot-import/template.csv?v=${moment().unix()}`}
									target="_blank"
									style={{ fontWeight: "bold", textDecoration: "underline" }}>
									CLICK HERE
								</a>{" "}
								to download the lot import template.
							</li>
							<li>Lot Uploads will be rejected in the case of duplicate Lot/Block/Section.</li>
						</ul>
						<Formik
							enableReinitialize
							initialValues={this.state.fields}
							validationSchema={this.validation}
							onSubmit={(values, actions) => {
								this.props.loadingStatus(true)
								submitData("lotImport", values)
									.then((data) => {
										//return
										this.props.loadingStatus(false)
										toast.success(data.message)
										actions.resetForm()
										this.setState({ ready: false, filename: "" })
										//return
									})
									.catch((e) => {
										actions.resetForm()
										toast.error(e.message, { autoClose: 10000 })
										this.props.loadingStatus(false)
										this.setState({ ready: false, filename: "" })
									})
							}}
							render={(f) => (
								<div className="editCommunity">
									<Form>
										{/*console.log(f)*/}
										<ul className="form__list">
											<li className={fieldStatus("property", f)}>
												<label htmlFor="property">Property</label>
												{f.errors.property && f.touched.property && (
													<div className="form__message">{f.errors.property}</div>
												)}
												<ReactSelect
													name={`property`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { label: v.name, value: v.id }
													})}
													value={f.values.property}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("neighborhood", f)}>
												<label htmlFor="neighborhood">
													Neighborhood <sup>*</sup>
												</label>
												{f.errors.neighborhood && f.touched.neighborhood && (
													<div className="form__message">{f.errors.neighborhood}</div>
												)}
												<ReactSelect
													name={`neighborhood`}
													options={this.propertyLimited(f, "neighborhoods")}
													value={f.values.neighborhood}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("lot_type", f)}>
												<label htmlFor="lot_type">Lot Type</label>
												{f.errors.lot_type && f.touched.lot_type && (
													<div className="form__message">{f.errors.lot_type}</div>
												)}
												<ReactSelect
													name={`lot_type`}
													options={this.propertyLimited(f, "lot_types")}
													value={f.values.lot_type}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("mud", f)}>
												<label htmlFor="mud">MUD</label>
												{f.errors.mud && f.touched.mud && (
													<div className="form__message">{f.errors.mud}</div>
												)}
												<ReactSelect
													name={`mud`}
													options={this.propertyLimited(f, "muds")}
													value={f.values.mud}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("lid", f)}>
												<label htmlFor="lid">LID</label>
												{f.errors.lid && f.touched.lid && (
													<div className="form__message">{f.errors.lid}</div>
												)}
												<ReactSelect
													name={`lid`}
													options={this.options("lids")}
													value={f.values.lid}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("isd", f)}>
												<label htmlFor="isd">ISD</label>
												{f.errors.isd && f.touched.isd && (
													<div className="form__message">{f.errors.isd}</div>
												)}
												<ReactSelect
													name={`isd`}
													options={this.options("isds")}
													value={f.values.isd}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("files", f, false, false, false)}>
												<label htmlFor="files">
													Excel File <sup>*</sup>
												</label>
												{f.errors.files && f.touched.files && (
													<div className="form__message">{f.errors.files}</div>
												)}
												{!this.state.ready && (
													<Dropzone
														multiple={false}
														onDrop={(files) => {
															this.onDrop(files, f)
														}}>
														{({ getRootProps, getInputProps }) => (
															<section className="dropzone">
																<div {...getRootProps()} className="dropbox__cont">
																	<input {...getInputProps()} />
																	<p className="dropzone__action">
																		Drag 'n' drop file here, or click to select
																		files
																	</p>
																</div>
															</section>
														)}
													</Dropzone>
												)}
												{this.state.ready && (
													<p style={{ color: "green" }}>Spreadsheet has been uploaded.</p>
												)}
											</li>
										</ul>
										<input
											type="submit"
											value={this.state.ready ? "Ready for Upload" : "Not Ready for Upload"}
											className={this.submitClasses(f.isValid)}
										/>
									</Form>
									<h3 style={{ marginTop: 50 }}>Site ID Numbers</h3>
									{this.buildSiteIDs()}
								</div>
							)}
						/>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({ loadingStatus }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(LotImport)
